import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import VueCookies from 'vue-cookies';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';

// Auth0
import { domain, clientId } from "../auth_config.json";
import { Auth0Plugin } from "./auth";

const datepickerOptions = {
  sundayFirst: true,
  daysShort: ["Mo","Tu","We","Th","Fr","Sa","Su"],
  colors: {
    selected: "#ffffff",
    inRange: "#ffffff",
    selectedText: "#000000",
    text: "#000000",
    inRangeBorder: "#ffffff",
    disabled: "#f2f2f2"
  }
};

Vue.use(VueMeta);

Vue.use(VueCookies, { expires: '30d', path: '/', domain: '.pilates.com', secure: 'true', sameSite: 'None'});

// Vue.use(VueCookies, { expires: '30d'});

// VueCookies.config('30d','/','.pilates.com',true);
// VueCookies.config('30d', '/');

Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
